import { useState } from 'react';
import { useHiddenSectionsContext } from '@/context/HiddenSectionsContext';
import { HideableSectionProvider } from '@/context/HideableSectionContext';
import { useUserReportPreferences } from '@/hooks/useUserReportPreferences';
import { Stack } from '@/theme/index';
import { HiddenSection } from '../HiddenSection/HiddenSection';

interface HideableSectionProps {
  id: string;
  nameToDisplay: string;
  nameToRecord: string;
  children?: React.ReactNode;
  isNested?: boolean;
}

export const HideableSection = ({
  id,
  nameToDisplay,
  nameToRecord,
  children,
  isNested = false,
}: HideableSectionProps) => {
  const [hasUnhidden, setHasUnhidden] = useState(false);
  const { updatePreferences } = useUserReportPreferences();
  const { hiddenSections, hideableSectionsFeatureActive, reportType } =
    useHiddenSectionsContext();
  const shouldDisplaySection = !hiddenSections?.includes(nameToRecord);

  const handleOnUnhide = () => {
    const userReportPreferences = {
      user_report_preferences: {
        [reportType]:
          hiddenSections?.filter((section) => section !== nameToRecord) || [],
      },
    };

    updatePreferences.mutate(userReportPreferences, {
      onSuccess: () => {
        setHasUnhidden(true);
      },
    });
  };

  if (shouldDisplaySection && hasUnhidden) {
    setHasUnhidden(false);
  }

  return (
    <HideableSectionProvider hideableSectionId={nameToRecord}>
      <Stack>
        {!hideableSectionsFeatureActive ||
        (hideableSectionsFeatureActive &&
          shouldDisplaySection &&
          Boolean(children)) ? (
          children
        ) : (
          <HiddenSection
            name={nameToDisplay}
            handleOnUnhide={handleOnUnhide}
            id={id}
            hasUnhidden={hasUnhidden && shouldDisplaySection}
            isLoading={updatePreferences.isLoading}
            isNested={isNested}
          />
        )}
      </Stack>
    </HideableSectionProvider>
  );
};
